module.exports = __webpack_public_path__ + "static/img/qssyLogo.33343bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/png/qssyLogo.jpg
// module id = 8oRS
// module chunks = 1